<template>
  <div class="d-flex flex-column">
    <!-- Jumbotron for add stripe -->
    <div v-if="!hasStripe" class="jumbotron jumbotron-fluid">
      <div class="container">
        <h1 class="display-4">TODO: Create a Stripe Payments Account</h1>
        <p class="lead">This will allow you to create paid events and collect profits.</p>
        <router-link to="/payments" class="btn btn-primary ml-auto">Set me up!</router-link>
      </div>
    </div>

    <!-- Header -->
    <div v-if="eventsPresent" class="text-center mt-5 text-secondary">
      <h1 class="d-inline-block display-4 faux-space-right">Your</h1>
      <div class="dropdown d-inline-block">
        <a class="d-flex" data-toggle="dropdown">
          <h1 class="d-inline-block mb-0 display-4 text-dropdown">{{ upcoming ? 'Upcoming' : 'Past' }}</h1>
          <h4 class="d-inline-block dropdown-toggle align-self-center mt-3"></h4>
        </a>
        <div class="dropdown-menu wide-dropdown">
          <a class="dropdown-item" :class="{ active: upcoming }"  @click="upcoming = true" href="#">Upcoming</a>
          <a class="dropdown-item" :class="{ active: !upcoming }" @click="upcoming = false" href="#">Past</a>
        </div>
      </div>
      <h1 class="d-inline-block display-4 faux-space-left">Events</h1>
    </div>
    <template v-else>
      <h1 class="text-secondary mt-5 text-center display-4">
        {{ upcoming ? 'Start Hosting' : 'No Past Events' }}
      </h1>
      <a class="mx-auto" href="#" @click="upcoming = !upcoming">
        {{ `View ${upcoming ? 'past' : 'upcoming'} events` }}
      </a>
    </template>

    <!-- Display events if present -->
    <EventCardDeck v-if="eventsPresent" :events="events" :upcoming="upcoming"/>

    <!-- Show AddEventCard else -->
    <NoEventsCard v-else :upcoming="upcoming"/>

  </div>
</template>

<script>
import EventCardDeck from '../components/EventCardDeck'
import EventsCardNoEvents from '../components/EventsCardNoEvents'
import EventsMixin from '../mixins/events'
import { Store } from '../store'

export default {
  components: {
    EventCardDeck: EventCardDeck,
    NoEventsCard: EventsCardNoEvents
  },
  mixins: [
    {
      methods: {
        fetchUpcomingEvents: EventsMixin.methods.fetchUpcomingEvents,
        fetchPastEvents: EventsMixin.methods.fetchPastEvents
      }
    }
  ],
  data () {
    return {
      upcoming: true
    }
  },
  computed: {
    hasStripe () {
      return Store.host.stripeAccount !== null
    },
    events () {
      return Object.filter(Store.events, (event) => this.upcoming ? event.isUpcoming() : event.isPast())
    },
    eventsPresent () {
      return Object.keys(this.events).length > 0
    }
  },
  created () {
    this.fetchUpcomingEvents().then(Store.addEvents)
      .catch()
    this.fetchPastEvents().then(Store.addEvents)
      .catch()
  },
  beforeRouteEnter (to, from, next) {
    // Allow incoming routes to specify that we should display past
    // events instead of upcoming to start
    const showPast = to.meta.showPast || false
    delete to.meta.showPast
    if (showPast) {
      next(vm => {
        vm.upcoming = false
      })
    } else {
      next()
    }
  }
}
</script>

<style scoped>
.text-dropdown {
  margin-right: 0.5rem;
  user-select: none;
}

.wide-dropdown {
  width: 93%;
}

.faux-space-left {
  margin-left: 0.9rem;
}

.faux-space-right {
  margin-right: 0.9rem;
}
</style>
